import '../styles/Inicio.css';

export default function Inicio() {
  return (
<div className="section  sectionInicio">
               
<div className="cartasPresentacion">
  <div className="textos">
    <div className="title">Tarot Angélico</div>
    <div className="subtitle">Trabajo desde la energía angélica!</div>
  </div>

  {/* Nueva fila de cartas */}
  <div className="filaCartas">
    <div className="headerpics foto1"></div>
    <div className="headerpics foto2"></div>
    <div className="headerpics foto3"></div>
    <div className="headerpics foto4"></div>
  </div>
</div>



            {/* 🎨 Ángeles decorativos */}
          <div className="angelesDecorativos">
            <img src="./images/angel1.png" alt="ángel"  className="angel angel1" />
            <img src="./images/angel2.png" alt="ángel"  className="angel angel2" />
            <img src="./images/angel3.png" alt="ángel" className="angel angel3" />
            <img src="./images/angel4.png" alt="ángel" className="angel angel4" />
          </div>
    </div>
  );
}
